module.exports = __webpack_public_path__ + "img/card_mantenimiento_dashboard.2ea3bc5a.svg";